import { createContext, PropsWithChildren, useContext } from 'react';
import { AppConfig } from '@/AppConfig';

const defaultConfig: AppConfig = {
  API_URL: '',
  NODE_ENV: 'development',
  ENABLE_PROFILING: false,
  MSW_ENABLE_MOCKING: false,
  PARENT_FRAME_ORIGIN: '',
  LAUNCH_DARKLY_CLIENT_ID: '',
  DATADOG_APPLICATION_ID: '',
  DATADOG_CLIENT_TOKEN: '',
  DATADOG_ENV: '',
  ENABLE_JOTAI_DEVTOOLS: false,
};

const ConfigContext = createContext<AppConfig>(defaultConfig);

interface ConfigProviderProps extends PropsWithChildren {
  config?: AppConfig;
}

export const ConfigProvider: React.FC<ConfigProviderProps> = ({
  config,
  children,
}) => {
  return (
    <ConfigContext.Provider value={config ? { ...config } : defaultConfig}>
      {config ? children : null}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  return useContext(ConfigContext);
};
